const TICKER_DELIMITER = /[,;\n\r\t]+/;
const KEYWORD_DELIMITER = /[,\n\r\t]+/;

const TICKER_DELIMITER_PROBE = /[,;\n\r\t]/;
const KEYWORD_DELIMITER_PROBE = /[,\n\r\t]/;

const MAX_TICKER_LEN = 30;

function dedupePreserveOrder(values: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const v of values) {
    if (!seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  }
  return out;
}

export function parsePastedTickers(text: string): string[] {
  const parts = text
    .split(TICKER_DELIMITER)
    .map((s) => s.trim().toUpperCase())
    .filter((s) => s.length > 0 && s.length <= MAX_TICKER_LEN);
  return dedupePreserveOrder(parts);
}

export function parsePastedKeywords(text: string): string[] {
  const parts = text
    .split(KEYWORD_DELIMITER)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return dedupePreserveOrder(parts);
}

export function containsTickerDelimiter(text: string): boolean {
  return TICKER_DELIMITER_PROBE.test(text);
}

export function containsKeywordDelimiter(text: string): boolean {
  return KEYWORD_DELIMITER_PROBE.test(text);
}

/**
 * Parse a CSV file's text content into tickers — strips the first line as
 * header (matches existing CSV upload behaviour across the portfolio builder).
 */
export function parseCsvTickers(text: string): string[] {
  const lines = text.split(/[\n\r]+/).slice(1);
  return parsePastedTickers(lines.join("\n"));
}

/**
 * Parse a CSV file's text content into keywords — strips the first line as
 * header to match the ticker CSV convention.
 */
export function parseCsvKeywords(text: string): string[] {
  const lines = text.split(/[\n\r]+/).slice(1);
  return parsePastedKeywords(lines.join("\n"));
}
